import { ExProductModel } from "../models";

export function isProductEditable(product?: ExProductModel) {
  return product?.article_type === "T";
}
